import axios from "axios";
import myAppConfig from "../../config";

const listTokensByUser = (userId) => {
  return axios
    .get(myAppConfig.api.ENDPOINT + `/api/v1/users/admin/refresh-tokens/${userId}`, { withCredentials: true })
    .then((response) => response);
};

const revokeTokensByUser = (userId) => {
  return axios
    .post(myAppConfig.api.ENDPOINT + `/api/v1/users/admin/refresh-tokens/${userId}/revoke`, {}, { withCredentials: true })
    .then((response) => response);
};

const listTokensByEmail = (email) => {
  return axios
    .get(myAppConfig.api.ENDPOINT + `/api/v1/users/admin/refresh-tokens/by-email/${encodeURIComponent(email)}`, { withCredentials: true })
    .then((response) => response);
};

const revokeTokensByEmail = (email) => {
  return axios
    .post(myAppConfig.api.ENDPOINT + `/api/v1/users/admin/refresh-tokens/by-email/${encodeURIComponent(email)}/revoke`, {}, { withCredentials: true })
    .then((response) => response);
};

const AdminTokensService = { listTokensByUser, revokeTokensByUser, listTokensByEmail, revokeTokensByEmail };

export default AdminTokensService;


